import { enum_, picklist } from 'valibot'

export enum StateMapDisk {
  Cloud = 'cloud',
  IndexedDB = 'idb',
  Memory = 'memory',
  Export = 'export',
  Workspace = 'workspace',
}

export const StateMapDiskSchema = enum_(StateMapDisk, 'Invalid Disk')
// Public parsing accepts only actual storage backends; dev-only placeholders (Export, Workspace) stay private until later steps.
export const PublicStateMapDiskSchema = picklist([StateMapDisk.Cloud, StateMapDisk.IndexedDB], 'Invalid Disk')
export const EXPORT_DISK_PLACEHOLDER_ERROR = 'Dev-only disk placeholder is not implemented'
export const WORKSPACE_DISK_PLACEHOLDER_ERROR = 'Workspace disk is only available in Vite dev mode'
